<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.records && !checkIfSignIsExist(user.id, 'records')" @click="$var('acceptRec', true)">Подписать</n-button>
      <n-button v-if="edit.lab && !checkIfSignIsExist(user.id, 'lab')" @click="$var('acceptLab', true)">Подписать</n-button>
      <n-button v-if="edit.master && !checkIfSignIsExist(user.id, 'master')" @click="$var('acceptMas', true)">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-input title="№ п.п." v-bind="$form.input('number')" :text="!edit.records" />
      <n-datepicker title="Дата и время записи" v-bind="$form.input('date')" :text="!edit.records" />
      <n-input title="Время между записями" v-bind="$form.input('time')" :text="!edit.records" />
      <n-input title="Сведения о ходе бетонирования и бетоне" v-bind="$form.input('information')" :text="!edit.records" />
      <n-input title="№ бетонолитных труб" v-bind="$form.input('pipeNumber')" :text="!edit.records" />
      <n-input title="Диаметр бетонолитной трубы, см" v-bind="$form.input('diameter')" :text="!edit.records" />
      <n-input title="Количество бетона, м3, уложенного в блок, анкеровка контрольных образцов бетона" v-bind="$form.input('concreteCount')" :text="!edit.records" />
      <n-input title="Средняя скорость бетонирования, м/ч" v-bind="$form.input('speed')" :text="!edit.records" />
      <n-input title="Отметка верха оболочки колодца ограждения, котлована и т.д." v-bind="$form.input('topMark')" :text="!edit.records" />
      <n-input title="Отметка грунта в полости оболочки, диаметр скважины, котлована, м" v-bind="$form.input('earthMark')" :text="!edit.records" />
      <n-input title="Отсчёт по трубе, м" v-bind="$form.input('pipeReport')" :text="!edit.records" />
      <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: у трубы " v-bind="$form.input('deep1')" :text="!edit.records" />
      <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 1" v-bind="$form.input('deep2')" :text="!edit.records" />
      <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 2" v-bind="$form.input('deep3')" :text="!edit.records" />
      <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 3" v-bind="$form.input('deep4')" :text="!edit.records" />
      <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 4" v-bind="$form.input('deep5')" :text="!edit.records" />
      <n-input title="Заглубление трубы в бетонную смесь, м" v-bind="$form.input('deepening')" :text="!edit.records" />
      <n-input title="Средний слой поверхности бетона" v-bind="$form.input('layer')" :text="!edit.records" />
      <n-input title="Уровень бетонной смеси в трубе от низа, м" v-bind="$form.input('level')" :text="!edit.records" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
    
    <c-modal-journal-do-sign v-if="$var('acceptRec')" @close="$var('acceptRec', false)" @submit="(s) => accept('records', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptLab')" @close="$var('acceptLab', false)" @submit="(s) => accept('lab', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptMas')" @close="$var('acceptMas', false)" @submit="(s) => accept('master', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status === 'waiting' && $app.auth.can('journals_spec35_records', this.project.id),
        lab: this.record.status === 'waiting' && $app.auth.can('journals_spec35_lab', this.project.id),
        master: this.record.status === 'waiting' && $app.auth.can('journals_spec35_master', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'spec35', this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec35.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec35.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
